import dot from 'dot-object';
import {createSelector} from 'reselect';

const selectConfig = ({config}) => config;

/* Returns a config-object with data and methods
for accessing that data.
*/
export const getConfigObject = createSelector(
  selectConfig,
  config => ({
    data: config?.config.data,
    error: config?.config.error,
    isFetching: config?.config.isFetching,

    /* Get a property using dot syntax.
    If there is no data or the final property or any properties along the way dosent exist,
    undefined is returned
    */
    getProperty: path => dot.pick(path, config.config.data),

    getRoutes: () => Object.getOwnPropertyNames(config.routes),
    hasRoute: route => config.routes[route] !== undefined,
  }),
);

export const getMode = ({config}) => config.editor?.mode;
export const getConfig = ({config}) => config;
export const getHasLoadedConfig = ({config}) => !!(!config.config.isFetching && !config.config.error && config.config.data);
